import { ToothIcon } from './ToothIcon';

/**
 * author: Christopher Schreiner
 * id 486D33E1-B181-40D4-B088-BBB49221B91F
 * name tooth
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tooth.svg
 * tags
 * - Medical / Hospital 
 */
export const DentistIcon = ToothIcon;
export default DentistIcon